/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Container } from '@mui/material'
import { FastabLogo } from 'assets/images'
import { restuarantData } from 'features/restaurant/restaurant'
import { tabData } from 'features/tab/tab'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'

interface props {
  restaurantName?: string
  areaName?: string
}
function Header({ restaurantName, areaName }: props) {
  const tableId = sessionStorage.getItem('tid')
  const establishmentId = sessionStorage.getItem('establishmentId')
  const navigate = useNavigate()
  const tabDetailData = useSelector(tabData)
  useEffect(() => {
    const url = window.location
    const isQrURL = url.toString().includes('tid')
    if ((!tableId || !establishmentId) && !isQrURL) {
      navigate('/home')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableId, establishmentId])
  const restaurantData = useSelector(restuarantData)

  return (
    <>
      <header className="mui-fixed">
        <Container className="header" maxWidth="md">
          <Link
            to={restaurantData?.restaurantId ? '/main-menu' : '/home'}
            className="logo"
          >
            <img src={FastabLogo} alt="FasTab" className="fastab-guest-logo" />
          </Link>
          {/* Only show restaurant info if there's actual data */}
          {(restaurantName ||
            areaName ||
            tabDetailData?.tableName ||
            sessionStorage.getItem('tn')) && (
            <div className="resturant-info">
              {/* Only show restaurant/area info if available */}
              {(restaurantName || areaName) && (
                <p>
                  {restaurantName && areaName
                    ? `${restaurantName} - ${areaName}`
                    : restaurantName || areaName}
                </p>
              )}
              {/* Only show table info if available */}
              {(tabDetailData?.tableName || sessionStorage.getItem('tn')) && (
                <small>
                  Table:{' '}
                  {(
                    tabDetailData?.tableName || sessionStorage.getItem('tn')
                  )?.replace('_', ' ')}
                </small>
              )}
            </div>
          )}
        </Container>
      </header>
    </>
  )
}

export default Header
